module.exports = __webpack_public_path__ + "static/media/platforms.71635633.svg";